import { render, staticRenderFns } from "./QaUpdateModal.vue?vue&type=template&id=6c95fb9e&scoped=true"
import script from "./QaUpdateModal.vue?vue&type=script&lang=js"
export * from "./QaUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./QaUpdateModal.vue?vue&type=style&index=0&id=6c95fb9e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c95fb9e",
  null
  
)

export default component.exports